import { EntityConfig } from '../hooks/useEntity';

export interface BudgetCategory {
  name: string;
  allocated: number;
  spent: number;
}

export interface Budget {
  id: string;
  userId: string;
  totalAmount: number;
  startDate: string;
  endDate: string;
  categories: BudgetCategory[];
  createdAt: string;
  updatedAt: string;
}

export interface SpendingTrend {
  id: string;
  userId: string;
  month: string;
  totalBudget: number;
  totalSpent: number;
  savedAmount: number;
  createdAt: string;
}

export const budgetEntityConfig: EntityConfig<Budget> = {
  entityType: 'Budget',
  properties: {
    userId: { type: 'string', required: true },
    totalAmount: { type: 'number', required: true },
    startDate: { type: 'string', required: true },
    endDate: { type: 'string', required: true },
    categories: { type: 'json', required: true },
    createdAt: { type: 'string', required: false },
    updatedAt: { type: 'string', required: false },
  },
  orderBy: { field: 'createdAt', direction: 'desc' },
};

export const spendingTrendEntityConfig: EntityConfig<SpendingTrend> = {
  entityType: 'SpendingTrend',
  properties: {
    userId: { type: 'string', required: true },
    month: { type: 'string', required: true },
    totalBudget: { type: 'number', required: true },
    totalSpent: { type: 'number', required: true },
    savedAmount: { type: 'number', required: true },
    createdAt: { type: 'string', required: false },
  },
  orderBy: { field: 'createdAt', direction: 'desc' },
};
